import { render, staticRenderFns } from "./WhyHeader.vue?vue&type=template&id=011aa2ac&scoped=true"
import script from "./WhyHeader.vue?vue&type=script&lang=js"
export * from "./WhyHeader.vue?vue&type=script&lang=js"
import style0 from "./WhyHeader.vue?vue&type=style&index=0&id=011aa2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011aa2ac",
  null
  
)

export default component.exports